export function todoistAge() {
    const start = new Date('2007/02/02') // Todoist start date
    const end = new Date()
    const elapsedMilliseconds = end.getTime() - start.getTime()
    const elapsedDays = elapsedMilliseconds / (1000 * 60 * 60 * 24)
    const years = Math.floor(elapsedDays / 365)
    const days = Math.floor(elapsedDays % 365)

    return {
        years,
        days,
    }
}
